import gql from "graphql-tag";

const resultField = `
  id
	plate
	model
	note
	seat
  createdAt
  updatedAt
`;
const EXPAND_FIELD = `
location {
  id
  name
}
locationId
driverEmployee {
  id
  code
  fullname
  email
}
driverEmployeeId
vehicleType {
  id
  model
  }
vehicleTypeId
`;

const createVehicle = gql`
  mutation(
    $plate: String
		$model: String
		$note: String
		$seat: Float
		$locationId: ID
		$driverEmployeeId: ID
    $vehicleTypeId: ID!
  ) {
    createVehicle(
      data: {
        plate: $plate
        model: $model
        note: $note
        seat: $seat
        locationId: $locationId
        driverEmployeeId: $driverEmployeeId
        vehicleTypeId: $vehicleTypeId
      }
    ) {
      ${resultField}
    }
  }
`;

const updateVehicle = gql`
  mutation(
    $id: ID!
    $plate: String
		$model: String
		$note: String
		$seat: Float
		$locationId: ID
		$driverEmployeeId: ID
    $vehicleTypeId: ID!
  ) {
    updateVehicle(
      id: $id
      data: {
        plate: $plate
        model: $model
        note: $note
        seat: $seat
        locationId: $locationId
        driverEmployeeId: $driverEmployeeId
        vehicleTypeId: $vehicleTypeId
      }
    ) {
      ${resultField}
    }
  }
`;

const deleteVehicle = gql`
  mutation($id: ID!) {
    deleteVehicle(id: $id) {
      id
    }
  }
`;

const getListVehicle = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
    $locationIds: [ID!]
    $driverEmployeeIds: [ID!]
  ) {
    getListVehicle(
      query: $query
      paging: { limit: $limit, page: $page }
      filter: {
        locationIds: $locationIds
        driverEmployeeIds: $driverEmployeeIds
      }
    ) {
      ${resultField}
      ${EXPAND_FIELD}
    }
  }
`;

const getDetailVehicle = gql`
  query($id: ID!) {
    getDetailVehicle(id: $id) {
      ${resultField}
      ${EXPAND_FIELD}
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  createVehicle,
  updateVehicle,
  deleteVehicle,
  getListVehicle,
  getDetailVehicle,
};
